export const getWidgets = store => store.homepageWidgets;
export const isLoaded = store => getWidgets(store).isLoaded;
export const getWidget = store => (isLoaded(store) ? getWidgets(store).widget : null);
